"use client";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Form, Row, Tab, Table, Tabs } from "react-bootstrap";
import { useEffect, useState } from "react";
import axios from "../axios/axios";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import ProtectedRouteAdmin from "../components/ProtectedRouteAdmin";

export default function AdminHome() {
  const [domaines, setDomaines] = useState([]);

  const token = Cookies.get("auth_token");
  const [id, setId] = useState("");
  const [nom, setNom] = useState("");
  const [domain_d_etude, setDomain_d_etude] = useState("");
  const [date_naissance, setDate_naissance] = useState("");
  const [niveau, setNiveau] = useState("");
  const [societe, setSociete] = useState("");
  const [email, setEmail] = useState("");

  const [lastCv, setLastCv] = useState([]);
  const [lastCvUpdated, setLastCvUpdated] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    afficherCvPourAdmin();
    getDomaines();
  }, []);

  const getDomaines = () => {
    axios
      .get("getDomainesEtEtablissementsEtEntreprises", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setDomaines(response.data.domaines);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const afficherCvPourAdmin = () => {
    axios
      .get(`/afficherCv`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setCount(response.data.count);
        setLastCv(response.data.cvs);
        setLastCvUpdated(response.data.cvupdated);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const chercher = (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append("id", id);
    form.append("nom", nom);
    form.append("date_naissance", date_naissance);
    form.append("domain_d_etude", domain_d_etude);
    form.append("niveau", niveau);
    form.append("societe", societe);
    form.append("email", email);

    axios
      .post(`/chercherCV`, form, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setLastCv(response.data.cvs);
        setCount(response.data.count);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <ProtectedRouteAdmin>
      <div id="section" className="signup mt-2">
        <div className="container card">
          Total de CVs : {count}
          <Tabs defaultActiveKey="home" id="uncontrolled-tab-example" fill>
            <Tab eventKey="home" title="List des 10 dernière cv">
              <Row className="mt-3 mb-3">
                <Col xs={12} sm={2}>
                  <Form.Label>ID</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="ID"
                    value={id}
                    onChange={(e) => setId(e.target.value)}
                  />
                </Col>
                <Col xs={12} sm={2}>
                  <Form.Label>Domaine d'études</Form.Label>
                  <Form.Select
                    aria-label="Domaine d'études"
                    value={domain_d_etude}
                    onChange={(e) => setDomain_d_etude(e.target.value)}
                  >
                    <option value="">---------</option>
                    {domaines.map((domaine, index) => (
                      <option value={domaine.nom} key={index}>
                        {domaine.nom}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col xs={12} sm={2}>
                  <Form.Label>Nom</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Nom"
                    value={nom}
                    onChange={(e) => setNom(e.target.value)}
                  />
                </Col>
                <Col xs={12} sm={2}>
                  <Form.Label>Annee de naissance</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Annee de naissance"
                    value={date_naissance}
                    onChange={(e) => setDate_naissance(e.target.value)}
                  />
                </Col>
                <Col xs={12} sm={2}>
                  <Form.Label>Niveau d'études</Form.Label>
                  <Form.Select
                    aria-label="Niveau d'études"
                    value={niveau}
                    onChange={(e) => setNiveau(e.target.value)}
                  >
                    <option value="">----------</option>
                    <option value="Certificat">Certificat</option>
                    <option value="Brevet">Berevet</option>
                    <option value="BAC">BAC</option>
                    <option value="BAC+2">BAC+2</option>
                    <option value="Licence">Licence</option>
                    <option value="BAC+4">BAC+4</option>
                    <option value="Master">Master</option>
                    <option value="Doctorat">Doctorat</option>
                    <option value="Autres">Autres</option>
                  </Form.Select>
                </Col>
                <Col xs={12} sm={2}>
                  <Form.Label>Société</Form.Label>
                  <Form.Control
                    type="text"
                    value={societe}
                    onChange={(e) => setSociete(e.target.value)}
                  />
                </Col>
                <Col xs={12} sm={2}>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Col>
                <Col xs={12} sm={2}>
                  <button className="btn btn-success mt-4" onClick={chercher}>
                    Chercher
                  </button>
                </Col>
              </Row>

              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nom</th>
                    <th>Date de naissance</th>
                    <th>E-mail</th>
                    <th>Tèl</th>
                    <th>Niveau d'études</th>
                    <th>Domaine</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {lastCv.map((cv, index) => (
                    <tr key={index}>
                      <td>{cv.id}</td>
                      <td>
                        <Link
                          to={`${process.env.PUBLIC_URL}/consulter-cv/${cv.id}`}
                        >
                          {cv.nom}
                        </Link>
                      </td>
                      <td>{cv.date_naissance}</td>
                      <td>{cv.email}</td>
                      <td>{cv.telephone}</td>
                      <td>{cv.niveau}</td>
                      <td>{cv.domain_d_etude}</td>
                      <td>
                        <Link
                          to={`${process.env.PUBLIC_URL}/modifier-cv/${cv.id}`}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab>

            <Tab eventKey="profile" title="List des 10 dernière cv modifier">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nom</th>
                    <th>Date de naissance</th>
                    <th>E-mail</th>
                    <th>Tèl</th>
                    <th>Niveau d'études</th>
                    <th>Domaine</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {lastCvUpdated.map((cv, index) => (
                    <tr key={index}>
                      <td>{cv.id}</td>
                      <td>
                        <Link
                          to={`${process.env.PUBLIC_URL}/consulter-cv/${cv.id}`}
                        >
                          {cv.nom}
                        </Link>
                      </td>
                      <td>{cv.date_naissance}</td>
                      <td>{cv.email}</td>
                      <td>{cv.telephone}</td>
                      <td>{cv.niveau}</td>
                      <td>{cv.domain_d_etude}</td>
                      <td>
                        <Link
                          to={`${process.env.PUBLIC_URL}/modifier-cv/${cv.id}`}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab>
          </Tabs>
        </div>
      </div>
    </ProtectedRouteAdmin>
  );
}
